import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';
import { createTextMaskInputElement } from 'text-mask-core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-coleta-cliente',
  templateUrl: './coleta-cliente.component.html',
  styleUrls: ['./coleta-cliente.component.scss']
})
export class ColetaClienteComponent implements OnInit {
  @ViewChild('successModal') successModal!: TemplateRef<any>;
  @ViewChild('errorModal') errorModal!: TemplateRef<any>;

  clienteForm: FormGroup;
  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  telefoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  showArvoreGenealogica = false;
  selectedParentesco: string = 'bisneto';
  documentos: File[] = [];
  errorMessage: string = '';
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private ajaxService: AjaxService,
    public modalService: NgbModal,
    private router: Router,
    public util: UtilService
  ) {
    this.clienteForm = this.fb.group({
      NOME: [''],
      cpf: ['', [Validators.required, Validators.pattern(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)]],
      email: ['', [Validators.required, Validators.email]],
      telefone: ['', Validators.required],
      endereco: ['', Validators.required],
      tipoDemanda: ['', Validators.required],
      parentesco: ['bisneto'],
      consulado: [''],
      temAgendamento: [false],
      nomeConsulado: [''],
      italiano: this.fb.group({
        nomeCompleto: [''],
        dataNascimento: [''],
        localNascimento: [''],
        nomeConjuge: [''],
        dataCasamento: [''],
        localCasamento: [''],
        dataObito: [''],
        localObito: ['']
      }),
      filhoItaliano: this.fb.group({
        nomeCompleto: [''],
        dataNascimento: [''],
        localNascimento: [''],
        nomeConjuge: [''],
        dataCasamento: [''],
        localCasamento: [''],
        dataObito: [''],
        localObito: ['']
      }),
      netoItaliano: this.fb.group({
        nomeCompleto: [''],
        dataNascimento: [''],
        localNascimento: [''],
        nomeConjuge: [''],
        dataCasamento: [''],
        localCasamento: [''],
        dataObito: [''],
        localObito: ['']
      }),
      bisnetoItaliano: this.fb.group({
        nomeCompleto: [''],
        dataNascimento: [''],
        localNascimento: [''],
        nomeConjuge: [''],
        dataCasamento: [''],
        localCasamento: [''],
        dataObito: [''],
        localObito: ['']
      }),
      trinetoItaliano: this.fb.group({
        nomeCompleto: [''],
        dataNascimento: [''],
        localNascimento: [''],
        nomeConjuge: [''],
        dataCasamento: [''],
        localCasamento: [''],
        dataObito: [''],
        localObito: ['']
      }),
      tetranetoItaliano: this.fb.group({
        nomeCompleto: [''],
        dataNascimento: [''],
        localNascimento: [''],
        nomeConjuge: [''],
        dataCasamento: [''],
        localCasamento: [''],
        dataObito: [''],
        localObito: ['']
      }),
      pentanetoItaliano: this.fb.group({
        nomeCompleto: [''],
        dataNascimento: [''],
        localNascimento: [''],
        nomeConjuge: [''],
        dataCasamento: [''],
        localCasamento: [''],
        dataObito: [''],
        localObito: ['']
      }),
      hexanetoItaliano: this.fb.group({
        nomeCompleto: [''],
        dataNascimento: [''],
        localNascimento: [''],
        nomeConjuge: [''],
        dataCasamento: [''],
        localCasamento: [''],
        dataObito: [''],
        localObito: ['']
      }),
      cliente: this.fb.group({
        nomeCompleto: [''],
        dataNascimento: [''],
        localNascimento: [''],
        nomeConjuge: [''],
        dataCasamento: [''],
        localCasamento: [''],
        filhos: [''],
        netos: ['']
      })
    });

    // Inicializar selectedParentesco
    this.selectedParentesco = 'bisneto';
  }

  ngOnInit(): void {
    // Observar mudanças no tipo de demanda
    this.clienteForm.get('tipoDemanda')?.valueChanges.subscribe(value => {
      if (value === 'jure_sanguinis') {
        this.showArvoreGenealogica = true;
        this.clienteForm.get('parentesco')?.setValidators([Validators.required]);
      } else {
        this.showArvoreGenealogica = false;
        this.clienteForm.get('parentesco')?.clearValidators();
        // Limpar campos relacionados ao jure sanguinis
        this.clienteForm.patchValue({
          temAgendamento: false,
          nomeConsulado: '',
          parentesco: ''
        });
        this.documentos = [];
      }
      this.clienteForm.get('parentesco')?.updateValueAndValidity();
    });

    // Observar mudanças no parentesco
    this.clienteForm.get('parentesco')?.valueChanges.subscribe(value => {
      this.selectedParentesco = value;
    });

    // Observar mudanças no agendamento
    this.clienteForm.get('temAgendamento')?.valueChanges.subscribe(value => {
      /*debugger
      if (value) {
        this.clienteForm.get('nomeConsulado')?.setValidators([Validators.required]);
      } else {
        this.clienteForm.get('nomeConsulado')?.clearValidators();
      }*/
      this.clienteForm.get('nomeConsulado')?.updateValueAndValidity();
    });
  }

  onFileSelected(event: any): void {
    const files = event.target.files;
    if (files) {
      for (let i = 0; i < files.length; i++) {
        this.documentos.push(files[i]);
      }
    }
  }

  removeDocumento(index: number): void {
    this.documentos.splice(index, 1);
  }

  onSubmit(): void {
    if (this.clienteForm.valid) {
      this.util.showLoading();

      let dadosQrcode = this.getDados(); 
      let formData = this.util.jsonToFormData(dadosQrcode);
      // Adicionar documentos
      this.documentos.forEach((doc, index) => {
        formData.append(`Arquivo`, doc);
      });

      var url = API + "Usuario/Cadastro/cliente";
      this.ajaxService.postFile(url, formData).subscribe({
        next: (response) => {
          this.util.closeLoading();
          this.modalService.open(this.successModal, { centered: true });
          this.clienteForm.reset();
          this.documentos = [];
        },
        error: (error) => {
          this.util.closeLoading();
          this.errorMessage = error.message || 'Erro ao cadastrar cliente';
          this.modalService.open(this.errorModal, { centered: true });
        }
      });
    }
  }
  getDados() {
    let dadosQrcode = {
      "NOME": this.clienteForm.value.NOME,
      "CPF": this.clienteForm.value.cpf,
      "EMAIL": this.clienteForm.value.email,
      "TELEFONE": this.clienteForm.value.telefone,
      "ENDERECO": this.clienteForm.value.endereco,
      "TIPO_DEMANDA": this.clienteForm.value.tipoDemanda
    }

    if(this.clienteForm.value.tipoDemanda == "jure_sanguinis"){
      const arvore = {
        italiano: this.clienteForm.value.italiano,
        filhoItaliano: this.clienteForm.value.filhoItaliano,
        netoItaliano: this.clienteForm.value.netoItaliano,
        bisnetoItaliano: this.clienteForm.value.bisnetoItaliano,
        trinetoItaliano: this.clienteForm.value.trinetoItaliano,
        tetranetoItaliano: this.clienteForm.value.tetranetoItaliano,
        pentanetoItaliano: this.clienteForm.value.pentanetoItaliano,
        hexanetoItaliano: this.clienteForm.value.hexanetoItaliano,
        cliente: this.clienteForm.value.cliente,
        parentesco: this.clienteForm.value.parentesco,
      };
      dadosQrcode["ARVORE"] = JSON.stringify(arvore);
      dadosQrcode["AGENDAMENTO_CONSULADO"] = this.clienteForm.value.temAgendamento
      dadosQrcode["CONSULADO"] = this.clienteForm.value.nomeConsulado
      //dadosQrcode["Arquivo"] = this.documentos;  
    }

    return dadosQrcode;
  }

  navigateToSection(sectionId: string): void {
    this.router.navigate(['/site'], { fragment: sectionId });
  }

  login(): void {
    this.router.navigate(['/login']);
  }
} 